'use strict';

module.exports = /([{}])\1|{([^}]*)}|(%)%|(%(\w*))/g;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/STRING_FORMAT_REG.js
// module id = 465
// module chunks = 0